/**
 * TODO: move configuration to bootstrap
 */

import 'bulma/css/bulma.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'vue-multichat/dist/VueChat.css'

import localeElementUIRu from 'element-ui/lib/locale/lang/ru-RU'
import localeElementUI from 'element-ui/lib/locale'

import isUndefined from 'lodash/isUndefined'
import Vue from 'vue'
import Resource from 'vue-resource'
import NProgress from 'vue-nprogress'
import { sync } from 'vuex-router-sync'
// import Axios from 'axios'
import Vuelidate from 'vuelidate'
import Multiselect from 'vue-multiselect'
import VueClip from 'vue-clip'
import 'vue-cropperjs'
import InputMask from 'vue-input-mask'
import VueClipboard from 'vue-clipboard2'
import Acl from 'vue-browser-acl'
import AclInstance from './acl'
import veeRu from 'vee-validate/dist/locale/ru'
import VeeValidate, { Validator } from 'vee-validate'
import vuetify from './plugins/vuetify'
import { VueEditor } from 'vue2-editor'

// import VueChatScroll from 'vue-chat-scroll'
import VueScrollTo from 'vue-scrollto'
import money from 'v-money'

import Bootstrap from './bootstrap'
import App from './App.vue'
import router from './router'
import store from './store'
import * as filters from './filters'
import UIElements from './components/elements'
import { TOGGLE_SIDEBAR, SET_CURRENT_USER } from './store/mutation-types'
import config from './config'
import AuthUser from './models/AuthUser'
import {
  Button, Select, Table, TableColumn, Tabs, TabPane, Loading, MessageBox, Notification,
  Message, Pagination, FormItem, Form, Option, Input, Row, Col, Alert, Tag, DatePicker, TimePicker
} from 'element-ui'
import components from './components'

localeElementUI.use(localeElementUIRu)

Vue.component(Button.name, Button)
Vue.component(Select.name, Select)
Vue.component(Table.name, Table)
Vue.component(TableColumn.name, TableColumn)
Vue.component(Pagination.name, Pagination)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component(FormItem.name, FormItem)
Vue.component(Form.name, Form)
Vue.component(Option.name, Option)
Vue.component(Input.name, Input)
Vue.component(Row.name, Row)
Vue.component(Col.name, Col)
Vue.component(Alert.name, Alert)
Vue.component(Tag.name, Tag)
Vue.component(DatePicker.name, DatePicker)
Vue.component(TimePicker.name, TimePicker)
Vue.component('multiselect', Multiselect)
Vue.component('input-mask', InputMask)
Vue.component('vue-editor', VueEditor)

for (let name in components) {
  Vue.component(name, components[name])
}

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message

Vue.use(Loading.directive)
Vue.use(VeeValidate)
Vue.use(Vuelidate)
Vue.use(Resource)
Vue.use(NProgress)
Vue.use(VueClip)
Vue.use(VueScrollTo)
Vue.use(VueClipboard)
Vue.use(money, {
  decimal: ',',
  thousands: '.',
  prefix: '',
  suffix: '',
  precision: 2,
  masked: true
})

Bootstrap.init()

Vue.config.productionTip = false

Vue.http.options.root = config.prefixUrlApi

Validator.localize('ru', veeRu)

Vue.http.interceptors.push((request, next) => {
  next((response) => {
    if (!isUndefined(request.silent) && request.silent) {
      return response
    }

    if (request.method !== 'GET' &&
      (response.status === 201 || response.status === 204)
    ) {
      Notification({
        message: request.method === 'DELETE' ? 'Удалено' : 'Сохранено',
        type: 'success',
        duration: 3000
      })
      return response
    } else if (
      response.status < 400
      // response.status === 404 ||
      // (response.status === 400 && response.body.message === 'Validation Failed')
    ) {
      return response
    } else {
      Notification({
        title: `Ошибка (${response.status})`,
        message: `
            <p>${response.body.message}</p>
            <p>RequestId: ${response.headers.get('request-id')}</p>
        `,
        dangerouslyUseHTMLString: true,
        type: 'error',
        duration: 5000
      })
      return response
    }
  })
})

sync(store, router)

const nprogress = new NProgress({ parent: '.nprogress-container' })

const { state } = store

router.beforeEach((to, from, next) => {
  console.log('ROUTE', to, from)
  next()
})

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

// register a global components
Object.keys(UIElements).forEach(key => {
  Vue.component(key, UIElements[key])
})

// auth
let authUser = new AuthUser(window.USER || {})
Vue.use(Acl, authUser, AclInstance, { router })
store.commit(SET_CURRENT_USER, authUser)

const app = new Vue({
  router,
  store,
  vuetify,
  nprogress,
  render: h => h(App)
})

export { app, router, store, authUser }
